module.exports = __webpack_public_path__ + "img/logo_sirka.66605d3d.png";